import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";

import Typography from "@mui/material/Typography";

import Box from "@subly/s1/ui/atom/Box";
import Button from "@subly/s1/ui/base/Button";

import { useLayoutMsal } from "features/layout/fabric";


Msal.Body = ({ children }: { children: React.ReactNode }) => {
	const { instance, accounts } = useMsal();
	const active = accounts.length > 0;

	const handleLogin = () => instance.loginPopup({ prompt: "select_account", scopes: [] });

	const style = {
		root: {
			alignItems: "center",
			justifyContent: "center",
			maxWidth: "sm",
			margin: "auto",
			height: "100vh"
		}
	};

	if (active) return (
		<AuthenticatedTemplate>
			{children}
		</AuthenticatedTemplate>
	);

	return (
		<UnauthenticatedTemplate>
			<Box.Column gap={2} sx={style.root} >
				<Typography variant="h2">You are not signed in</Typography>
				<Button variant="contained" color="secondary" onClick={handleLogin}>Sign in</Button>
			</Box.Column>
		</UnauthenticatedTemplate>
	);
};

export default function Msal({ children }: { children: React.ReactNode }) {
	const layout = useLayoutMsal();

	if (layout.isSuccess) return (
		<MsalProvider instance={layout.data}>
			<Msal.Body>
				{children}
			</Msal.Body>
		</MsalProvider>
	);
}